import React from 'react'
import InfoDialogUI from '../../components/InfoDialog/InfoDialogUI'

function SubscriptionStatusModal({
  show = false,
  title = '',
  icon = null,
  heading = '',
  description = '',
  onClose = null,
  actions = null,
  isV2 = false,
  preventClose = false
}) {
  if (!show || !heading) return null;

  const Icon = icon;

  if (isV2) return <StatusModal {...{ show, heading, onClose, icon, description , preventClose }} />;

  return (
    <InfoDialogUI show={show} title={title} onClose={onClose}>
      <div>
        {Icon && <Icon />}
        <h3
          style={{
            margin: '20px 0 8px',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '16px',
            lineHeight: '120%',
            letterSpacing: '0.01em',
            color: '#202020',
          }}>
          {heading}
        </h3>
        <p
          style={{
            margin: '0 0 48px',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '16px',
            lineHeight: '120%',
            letterSpacing: '0.01em',
            color: '#6F6F6F',
          }}>
          {description}
        </p>
        {actions}
      </div>
    </InfoDialogUI>
  );
}

export default SubscriptionStatusModal;

const StatusModal = ({
  show = false,
  heading = '',
  icon = null,
  description = '',
  onClose = null,
  preventClose = false,
}) => {
  const Icon = icon;

  return (
    <InfoDialogUI size="md" show={show} title="" onClose={onClose} preventClose={preventClose}>
      <div
        className="d-flex flex-column align-items-center justify-content-center gap-3 mx-auto w-100"
        style={{
          maxWidth: 300,
        }}>
        {Icon && <Icon />}
        <h3 className="m-0 text-center">{heading}</h3>
        {description ? <p className="m-0 text-center">{description}</p> : null}
      </div>
    </InfoDialogUI>
  );
};

